import { MdAttachMoney } from "react-icons/md";
import { IoTimerOutline } from "react-icons/io5";
import { MdLocalAtm } from "react-icons/md";

import ashton from "./photos/ashton.JPG";
import abigale2 from "./photos/abigale2.jpg";
import abigale3 from "./photos/abigale3.JPG";
import jasline from "./photos/jasline.jpg";
import brittney from "./photos/brittney.JPG";
import jace from "./photos/jace.jpg";
import jaylen from "./photos/jaylen.JPG";
import sirrea2 from "./photos/sirrea2.JPG";
import sirrea from "./photos/sirrea3.JPG";
import sirrea4 from "./photos/sirrea4.JPG";
import sirrea5 from "./photos/sirrea5.jpg";
import sirrea6 from "./photos/sirrea6.JPG";
import rachely from "./photos/rachely.JPG";
import rachely2 from "./photos/rachely2.JPG";
import rachely3 from "./photos/rachely3.JPG";
import rachely4 from "./photos/rachely4.jpg";
import niah from "./photos/niah.jpg";
import shoniah2 from "./photos/shoniah2.JPG";
import abigale from "./photos/abigaleBoudoir.jpg";
import zianna2 from "./photos/zianna2.JPG";
import zianna from "./photos/zianna.JPG";
import zianna3 from "./photos/zianna3.JPEG";
import zianna4 from "./photos/zianna4.JPG";
import zianna5 from "./photos/zianna5.JPG"
import tessa from "./photos/tessa.JPG";
import tessa2 from "./photos/tessa2.JPG";
import cassidy from "./photos/cassidy.JPG";
import karinaP2 from "./photos/KarinaP2.JPG";
import karina from "./photos/karina.JPG";
import karinaP from "./photos/KarinaP.JPG";
import karen from "./photos/karen.JPG";
import karen2 from "./photos/karen2.JPG";
import zenobia from "./photos/zenobia.JPG";
import zenobia2 from "./photos/zenobia2.jpg";
import zenobia3 from "./photos/zenobia3.JPG";
import gavin from "./photos/gavin.JPG";
import nashalae from "./photos/nashalae.JPG";
import lizz from "./photos/liz.JPG";
import lizz2 from "./photos/liz2.JPG";
import edny from "./photos/edny.JPG";
import edward from "./photos/edward.JPG";
import devonte from "./photos/devonte2.JPG";
import cesar from "./photos/cesar.JPG";
import nacier from "./photos/nacier.JPG";
import jorden from "./photos/jorden.JPG";
import jordan2 from "./photos/jordan2.JPG";
import jordan3 from "./photos/jordan3.JPG";
import jordan4 from "./photos/jordan4.JPG";
import caston from "./photos/caston.JPG";


import j32 from "./photos/J32.JPG";
import j3 from "./photos/J3.JPG";
import j4 from "./photos/J4.JPG";
import j42 from "./photos/J42.JPG";
import nb90602 from "./photos/NB90602.JPG";
import nb9060 from "./photos/NB9060.JPG";
import timbs from "./photos/timbs.JPG";
import timbs2 from "./photos/timbs2.JPG";
import overbreak from "./photos/overbreak.JPG";
import j1 from "./photos/J1.JPG";
import smokegrey1 from "./photos/smokegrey1.JPG";
import crocs from "./photos/crocs.jpg";
import shimma from "./photos/shimma.JPG";
import shimma2 from "./photos/shimma2.JPG";
import melo from "./photos/melo.jpg";
import melo2 from "./photos/melo2.jpg";
import nb from "./photos/NB.JPG";
import nb2 from "./photos/NB2.JPG";


export const categories = [
  {
    name: "LIFESTYLE",
    coverImage: sirrea4, // Cover image for the nature category
  },
  
  {
    name: "PORTRAIT",
    coverImage: zianna2, // Cover image for the architecture category
  },

  {
    name: "BOUDOIR",
    coverImage: zenobia2,
  },

  {
    name: "ART ON FEETS",
    coverImage: j32,
  },
  
];

export const photoshoots = [
  {
    photo: sirrea4,
    category: "LIFESTYLE"
  },
  
  {
    
    photo: sirrea2,
    category: "LIFESTYLE"
  },

  {
    photo: sirrea,
    category: "LIFESTYLE"
  },

  {
    photo: rachely,
    category: "LIFESTYLE"
  },

  {
    photo: rachely2,
    category: "LIFESTYLE"
  },

  {
    photo: rachely3,
    category: "LIFESTYLE"
  },
  
  {
    photo: zianna3,
    category: "LIFESTYLE",
  },
  
  {
    photo: niah,
    category: "LIFESTYLE"
  },

  {
    photo: shoniah2,
    category: "LIFESTYLE"
  },
  
  {
    photo: tessa,
    category: "LIFESTYLE"
  },

  {
    photo: tessa2,
    category: "LIFESTYLE"
  },

  {
    photo: cassidy,
    category: "LIFESTYLE"
  },

  {
    photo: karinaP2,
    category: "LIFESTYLE"
  },

  {
    photo: karina,
    category: "LIFESTYLE"
  },

  {
    photo: karinaP,
    category: "LIFESTYLE"
  },

  {
    photo: nashalae,
    category: "LIFESTYLE"
  },

  {
    photo: lizz2,
    category: "LIFESTYLE"
  },

  {
    photo: karen,
    category: "LIFESTYLE"
  },

  {
    photo: karen2,
    category: "LIFESTYLE"
  },

  {
    photo: edny,
    category: "LIFESTYLE"
  },

  {
    photo: zianna2,
    category: "PORTRAIT"
  },

  {
    photo: zianna4,
    category: "PORTRAIT"
  },

  {
    photo: sirrea5,
    category: "PORTRAIT"
  },

  {
    photo: sirrea6,
    category: "PORTRAIT"
  },

  {
    photo: rachely4,
    category: "PORTRAIT"
  },

  {
    photo: brittney,
    category: "PORTRAIT"
  },

  {
    photo: jasline,
    category: "PORTRAIT"
  },
  
  {
    photo: lizz,
    category: "PORTRAIT"
  }, 

  {
    photo: jordan3,
    category: "PORTRAIT"
  },

  {
    photo: ashton,
    category: "PORTRAIT"
  },
  
  {
    photo: zenobia2,
    category: "BOUDOIR"
  },
  
  {
    photo: zenobia,
    category: "BOUDOIR"
  },

  {
    photo: zenobia3,
    category: "BOUDOIR"
  },

  {
    photo: zianna,
    category: "BOUDOIR",
  },

  {
    photo: zianna5,
    category: "BOUDOIR",
  },

  {
    photo: abigale,
    category: "BOUDOIR"
  },

  {
    photo: abigale2,
    category: "BOUDOIR"
  },

  {
    photo: abigale3,
    category: "BOUDOIR"
  },
  
  {
    photo: jace,
    category: "LIFESTYLE"
  },

  {
    photo: edward,
    category: "LIFESTYLE"
  },

  {
    photo: devonte,
    category: "LIFESTYLE",
  },

  {
    photo: gavin,
    category: "LIFESTYLE"
  },

  {
    photo: jaylen,
    category: "LIFESTYLE"
  },

  {
    photo: nacier,
    category: "LIFESTYLE"
  },

  {
    photo: jordan2,
    category: "LIFESTYLE"
  },

  {
    photo: jordan4,
    category: "LIFESTYLE"
  },

  {
    photo: jorden,
    category: "LIFESTYLE"
  },

  {
    photo: cesar,
    category: "LIFESTYLE"
  },

  {
    photo: caston,
    category: "LIFESTYLE"
  },

  {
    name: "Jordan 3s Denim 'Fired Red'",
    photo: j32,
    category: "ART ON FEETS"
  },

  {
    photo: j3,
    category: "ART ON FEETS"
  },

  {
    name: "Jordan 4s 'Oxidized Green'",
    photo: j4,
    category: "ART ON FEETS"
  },

  {
    photo: j42,
    category: "ART ON FEETS"
  },

  {
    name: "New Balance 9060 'Rain Cloud'",
    photo: nb90602,
    category: "ART ON FEETS"
  },

  {
    photo: nb9060,
    category: "ART ON FEETS"
  },

  {
    name: "Timbaland 'Limited Gold Edition'",
    photo: timbs,
    category: "ART ON FEETS"
  },

  {
    photo: timbs2,
    category: "ART ON FEETS"
  },

  {
    name: "Nike Undercover x Overbreak SP 'OVERCAST'",
    photo: overbreak,
    category: "ART ON FEETS"
  },

  {
    name: "Jordan 1s 'Black White 2.0'",
    photo: j1,
    category: "ART ON FEETS"
  },

  {
    name: "Jordan 1s 'Smoke Grey'",
    photo: smokegrey1,
    category: "ART ON FEETS"
  },

  {
    name: "Salehe Bembury x Crocs",
    photo: crocs,
    category: "ART ON FEETS"
  },

  {
    name: "Airmax 1s 'Shima Shima'",
    photo: shimma,
    category: "ART ON FEETS"
  },

  {
    photo: shimma2,
    category: "ART ON FEETS"
  },

  {
    name: "Jordan 9s 'Melo'",
    photo: melo,
    category: "ART ON FEETS"
  },

  {
    photo: melo2,
    category: "ART ON FEETS"
  },

  {
    name: "New Balance 2002r 'Protection Pack'",
    photo: nb,
    category: "ART ON FEETS"
  },

  {
    photo: nb2,
    category: "ART ON FEETS"
  },

  
];

export const prices = [
  {
    id: 1,
    icon: <MdAttachMoney />,
    title: "Prices",
    text: "Studio (1 Person): $200+",
    text2: "Studio (2 People): $350+",
    text3: "Studio (Groups over 3+): $500+",
    text4: "Outdoor (1 Person): $150",
    text5: "Outdoor (2 People): $200",
    text6: "Outdoor (Groups over 3+): $400+",
  },
];

export const requirements = [
  // {
  //   id: 1,
  //   icon: <IoTimerOutline />,
  //   text: "TIME MANAGEMENT",
  //   amount: "",
  //   tab: "PLEASE BE ON TIME!",
  // },
  // {
  //   id: 2,
  //   icon: <MdLocalAtm />,
  //   text: "DEPOSIT",
  //   amount:
  //     "ZELLE OR CASH",
  // },
];
